define('drops/dropdown/dropdown',[
    'jquery',
    'lq/drop',
    'lq/style',
    'lq/util',
    'underscore',
    'lq/tooltip',
    'lq/html',
    'lq/required'
], function ($, Drop, Style, util, _, Tooltip, html, Required) {
    'use strict';

    var defaults = {
        data: {
            showEmptyItem: true,
            title: {
                option: Tooltip.hardcoded
            },
            required: {
                initialVisibility: true,
                isRequired: false,
                valueSource: 'hardcoded'
            }
        }
    };

    function Dropdown(options) {
        Drop.call(this, $('<div/>'), defaults, options);

        this.data.eventing = util.convertListOfKeyValuesToObject(this.data.eventing);
        this.loaded = false;
        this.value = null;
        this.valueIsNumber = false;

        this.$element
            .addClass('boxToBorderSize')
            .css({
                whiteSpace: 'pre-wrap'
            });

        var self = this;
        this.$dropDown = $('<select />')
            .attr('id', this.rootDrop.instanceId + '_' + this.data.id)
            .css({
                width: '100%',
                height: '100%',
                textOverflow: 'ellipsis'
            })
            .on('change', this.valueChanged.bind(this))
            .attr('tabindex', self.data.tabIndex)
            .appendTo(self.$element);

        if (this.data.showEmptyItem) {
            this.$dropDown.addClass('dropdown-placeholder');
            this.$dropDown.addClass('empty');
        }

        Style.renderStyles(this, null, this.$dropDown);

        if (this.data.readOnly)
            this.$dropDown.prop('disabled', true);

        this.$dropDown.on('change', function () {
            if (self.$dropDown.val()) {
                var arg = self.$dropDown.val();
                self.triggerEventIfEnabled('selected', arg);
                self.triggerEventIfEnabled('changed', arg);
            } else {
                self.triggerEventIfEnabled('deselected', null);
                self.triggerEventIfEnabled('changed', null);
            }
        });

        this.$dropDown.on('change', function () {
            self.updateRequiredIndicator();
        });

        this.tooltip = new Tooltip(this, this.data.title, this.$dropDown);
    };

    Drop.extend(Dropdown, Drop);

    Dropdown.typeName = 'Dropdown';

    Dropdown.prototype.preRender = function () {
        var self = this;
        this.tooltip.update();
        this.piping.visibility.apply(this);
        this.piping.required.apply(this, function(requiredData) {
            if (requiredData && self.defaultOption) {
                self.defaultOption.css({display: 'none'});
            } else if (self.defaultOption) {
                self.defaultOption.css({display: ''});
            } else {
                self.requiredInitialState = requiredData;
            }
        });
        this.piping.datasources.registerDatasourceListener(
            this.data.dataSource,
            function (data) { self._update(data); },
            function (params) {
                if (self.data.pageSize) {
                    params.pageSize = self.data.pageSize;
                }
            });
        Required.prototype.addRemoveRequiredIndicator(self);

        this.applyPosition();
        this.renderMockData();
    };

    Dropdown.prototype.postRender = function () {
        this.$dropDown.css('padding-right', 'max(23px, ' + this.$dropDown.css('padding-right') + ')');
    };

    Dropdown.prototype.valueChanged = function() {
        var val = this.$dropDown.val();

        if (val === '') {
            this.value = null;
            this.$dropDown.addClass('dropdown-placeholder');
        } else {
            this.value = val;
            this.$dropDown.removeClass('dropdown-placeholder');
        }
        this.updateEmptyState();
    };

    Dropdown.prototype.createEmptyItem = function() {
        this.defaultOption = $('<option />')
            .val('')
            .text(this.data.emptyItemText || '...')
            .addClass('dropdown-placeholder');

        if (this.requiredInitialState) {
            this.defaultOption.css({display: 'none'});
        }
        return this.defaultOption;
    };

    Dropdown.prototype.renderMockData = function () {
        if (this.data.showEmptyItem)
            this.$dropDown.append(this.createEmptyItem());

        if (!this.data.mockData) return;

        this.$dropDown.append(_.map(this.data.mockData.split('\n'), function(item) {
            return $('<option />', {
                value: item,
                text: item
            });
        }));
    };

    Dropdown.prototype._update = function (data) {
        this.loaded = true;

        this.$dropDown
            .find('option')
            .remove()
            .end();

        if(this.data.showEmptyItem)
            this.$dropDown.append(this.createEmptyItem());

        var self = this;
        $.each(data.results, function (key, result) {
            var val = result[self.data.selectedKeyColumn || 'Id'];
            self.valueIsNumber = (typeof val === 'number');

            var $option = $('<option />', {
                value: val,
                text: html.strip(self.getDisplayStringFromResult(result))
            });

            Style.renderStyles(self, null, $option);

            $option.appendTo(self.$dropDown);
        });

        if (this.value)
            this.setValue({ value: this.value });
        else
            this.selectFirstItem();
    };

    Dropdown.prototype.getDisplayStringFromResult = function (result) {
        var column = this.getNameOfDisplayedColumn(result);
        return result[column];
    };

    Dropdown.prototype.getNameOfDisplayedColumn = function (result) {
        var keys = Object.keys(result);
        if (keys.length === 1) {
            return keys[0];
        }
        if (keys.indexOf(this.data.selectedColumnToShow) !== -1) {
            return this.data.selectedColumnToShow;
        }
        if (keys[0].toUpperCase() !== "ID") {
            return keys[0];
        }
        return keys[1];
    };

    Dropdown.prototype.focus = function () {
        this.$dropDown.trigger('focus');
    };

    Dropdown.prototype.getValue = function () {
        if (this.valueIsNumber && this.value !== null)
            return parseInt(this.value);
        return this.value === undefined
            ? null
            : this.value;
    };

    Dropdown.prototype.clearValue = function () {
        if (this.data.showEmptyItem) {
            this.$dropDown.addClass('empty');
            this.value = null;
            var self = this;
            setTimeout(function() {
                self.$dropDown.val('');
                self.$dropDown.addClass('dropdown-placeholder');
            });
        } else {
            this.selectFirstItem();
        }

        this.updateRequiredIndicator();
    };

    Dropdown.prototype.selectFirstItem = function () {
        var firstOption = this.$dropDown.find('option:first');
        this.$dropDown.val(firstOption.val());
        this.valueChanged();
    };

    Dropdown.prototype.setValue = function (update) {
        if (!this.loaded) {
            this.value = update.value;
        } else {
            if (update.value !== null && update.value !== undefined) {
                var option = _.find(this.$dropDown.children(), function(option) {
                    return option.value === update.value.toString();
                });

                if (option) {
                    this.value = update.value;
                    var self = this;

                    if (this.value === '') {
                        this.$dropDown.addClass('dropdown-placeholder');
                    } else {
                        this.$dropDown.removeClass('dropdown-placeholder');
                    }

                    // in some cases the correct item might not be selected if we don't add a timeout
                    setTimeout(function() {
                        self.$dropDown.val(update.value.toString());
                        self.updateEmptyState();
                        self.updateRequiredIndicator();
                    });
                } else {
                    this.triggerEventIfEnabled('valueNotFound', update.value);
                    if(!this.isEventEnabled('valueNotFound')) {
                        alert('A value was mapped onto a drop down list, but the corresponding item was not found in the list. Saving this form will cause you to lose this information.');
                    }

                    this.clearValue();
                }
            } else {
                this.clearValue();
            }
        }
        this.updateEmptyState();
        this.updateRequiredIndicator();
    };

    Dropdown.prototype.updateEmptyState = function () {
        var val = this.$dropDown.val();
        if (val === undefined || val === null || val === '') {
            this.$dropDown.addClass('empty');
        } else {
            this.$dropDown.removeClass('empty');
        }
    };

    return Dropdown;
});




